import * as _ from "lodash"
import {Schema} from "js-data";
import * as PASchema from "./PAdbSchema";
import {
    dctLogicalKeysByEntitySet,
    dctMapperToKeyGenSpecs,
    dctNonParentForeignKeysByEntitySet,
    dctSchemaByEntitySet,
    dctTableNameByEntitySet,
    KeyGenSpecs_default,
} from "./PAdbSchema";


export const WB_DataMart = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'DataMarts', // optional
    description: 'Schema for WB_DataMart records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_DATAMART_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "DM_ID": {
            "type": "string",
            "length": 50
        },
        "DM_NAME": {
            "type": "string",
            "length": 256
        },
        "DM_TYPE": {
            "type": "string",
            "length": 50
        },
        "WB_MDSET_ID": {
            "type": "number"
        },
        "WB_SALESORG_ID": {
            "type": "number"
        },
        "WB_ENTITY_ID_CUSTOMER": {
            "type": "number"
        },
        "WB_ENTITY_ID_PRODUCT": {
            "type": "number"
        },
        "WB_ENTITY_ID_PERIOD": {
            "type": "number"
        },
        "UPDATE_POLICY": {
            "type": "string",
            "length": 50
        },
        "PLAN_SCOPE_MANUAL_IND": {
            "type": "string",
            "length": 1
        },
        "WB_PERIOD_ID_START": {
            "type": "number"
        },
        "WB_PERIOD_ID_END": {
            "type": "number"
        },
        "MARGINAL_CNS_DRIVEN_POLICY": {
            "type": "string",
            "length": 50
        },
        "MARGINAL_EXCESS_SHP_POLICY": {
            "type": "string",
            "length": 50
        },
        "MARGINAL_OVERAGE_POLICY": {
            "type": "string",
            "length": 50
        },
        "INCLUDE_REF_DATA_IND": {
            "type": "string",
            "length": 1
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        }
    }
})

export const WB_DataMart_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_DataMart_Plan_Relationship]: {
            foreignKey: 'WB_DATAMART_ID',
            foreignKeyImmutable: true,
            localField: 'DataMartPlnRs'
        },
    },
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {foreignKey: 'WB_MDSET_ID', foreignKeyImmutable: true, localField: 'MDSet'},
        [PASchema.esWB_SalesOrg]:       {foreignKey: 'WB_SALESORG_ID', foreignKeyImmutable: true, localField: 'SalesOrg'},
        [PASchema.esWB_Entity]:         [
            {foreignKey: 'WB_ENTITY_ID_CUSTOMER', foreignKeyImmutable: true, localField: 'CustomerEntity'},
            {foreignKey: 'WB_ENTITY_ID_PRODUCT', foreignKeyImmutable: true, localField: 'ProductEntity'},
            {foreignKey: 'WB_ENTITY_ID_PERIOD', foreignKeyImmutable: true, localField: 'PeriodEntity'}
        ],
        [PASchema.esWB_Period]: [
            {foreignKey: 'WB_PERIOD_ID_START', foreignKeyImmutable: true, localField: 'PeriodStart'},
            {foreignKey: 'WB_PERIOD_ID_END', foreignKeyImmutable: true, localField: 'PeriodEnd'},
        ],
    }
}

export const WB_DataMart_Plan_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'DataMartPlnRs', // optional
    description: 'Schema for WB_DataMartPlnR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_DATAMARTPLNR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_DATAMART_ID": {
            "type": "number"
        },
        "WB_PLAN_ID": {
            "type": "number"
        },
        "MANUAL_IND": {
            "type": "string",
            "length": 1,
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
    }
})

export const WB_DataMart_Plan_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_DataMart]: {foreignKey: 'WB_DATAMART_ID', foreignKeyImmutable: true, localField: 'DataMart'},
        [PASchema.esWB_Plan]: {foreignKey: 'WB_PLAN_ID', foreignKeyImmutable: true, localField: 'Plan'},
    },
}


// Dictionaries
//-- Schemas
_.defaults(dctSchemaByEntitySet,
    {
        [PASchema.esWB_DataMart]: WB_DataMart,
        [PASchema.esWB_DataMart_Plan_Relationship]: WB_DataMart_Plan_Relationship,
    })


//-- Table Names
_.defaults(dctTableNameByEntitySet,
    {
        [PASchema.esWB_DataMart]: "/AZR/WB_DATAMART",
        [PASchema.esWB_DataMart_Plan_Relationship]: "/AZR/WB_DATAMARTPLNR",
    })


//-- Logical Key
_.defaults(dctLogicalKeysByEntitySet, {
    [PASchema.esWB_DataMart]: [],
    [PASchema.esWB_DataMart_Plan_Relationship]: [],
})


//-- Other Foreign Keys without jsData  Relationship
_.defaults(dctNonParentForeignKeysByEntitySet, {
    [PASchema.esWB_DataMart]: {},
    [PASchema.esWB_DataMart_Plan_Relationship]: {},
})


//-- Key Pools
_.defaults(dctMapperToKeyGenSpecs, {
    [PASchema.esWB_DataMart]: {sequence_name: "/AZR/WB_DATAMART_SEQ", ...KeyGenSpecs_default},
    [PASchema.esWB_DataMart_Plan_Relationship]: {sequence_name: "/AZR/WB_DATAMARTPLNR_SEQ", ...KeyGenSpecs_default},
})
